import React, { useEffect, useState } from 'react';
import { Button } from '../../../components/ui/button';
import { FileDown } from 'lucide-react';
import { toast } from 'sonner';
import api from '../../../utils/axios';
import { exportSectionPDF } from '../dashboard/exportPdf';

// Botón "Exportar PDF" reutilizable por sección. Captura automáticamente las
// métricas y los gráficos dentro de `targetRef` y genera un informe compacto.
export const SectionExportButton = ({ title, targetRef, testId = 'section-export-btn' }) => {
  const [exporting, setExporting] = useState(false);
  const [branding, setBranding] = useState({ nombre: 'AlertGuard', logo: null });

  useEffect(() => {
    api.get('/branding/public')
      .then((r) => setBranding({ nombre: r.data?.nombre_empresa || 'AlertGuard', logo: r.data?.logo_header || r.data?.logo_login || null }))
      .catch(() => {});
  }, []);

  const onClick = async () => {
    if (!targetRef?.current) return;
    setExporting(true);
    try {
      await exportSectionPDF(targetRef.current, { title, empresa: branding.nombre, logo: branding.logo });
      toast.success('Informe PDF generado');
    } catch (e) {
      toast.error('No se pudo exportar el PDF');
    } finally {
      setExporting(false);
    }
  };

  return (
    <Button variant="outline" onClick={onClick} disabled={exporting} data-testid={testId}>
      <FileDown className="h-4 w-4 mr-1" /> {exporting ? 'Generando…' : 'Exportar PDF'}
    </Button>
  );
};

export default SectionExportButton;
